:host {
  display: inline-flex;
  --loading-animation-duration: 2s;
  --loading-transition-duration: 0.5s;
}

.br-loading {
  display: flex;
  align-items: center;
  justify-content: center;

  &.loading-mode-spinner {
    margin: 16px;
  }

  &.loading-mode-progress {
    margin: 28px;
  }
}

.loading-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.loading-label-top {
  flex-direction: column;
}

.loading-label-bottom {
  flex-direction: column;
}

.loading-label-right {
  flex-direction: row;
}

.loading-label-left {
  flex-direction: row;
}

.loading-label-top .loading-label {
  margin-bottom: 8px;
  margin-top: 0;
  text-align: center;
}

.loading-label-bottom .loading-label {
  margin-top: 8px;
  margin-bottom: 0;
  text-align: center;
}

.loading-label-right .loading-label {
  margin-left: 8px;
  margin-right: 0;
  text-align: left;
}

.loading-label-left .loading-label {
  margin-left: 8px;
  margin-right: 0;
  text-align: left;
}

.loading-spinner,
.loading-progress {
  display: block;
  transform-origin: center;
}

.loading-spinner {
  animation: loading-rotate var(--loading-animation-duration) linear infinite;
}

.loading-spinner-track {
  stroke: var(--gray-20);
  transform: rotate(-90deg);
  transform-origin: center;
}

.loading-indicator {
  stroke: var(--blue-warm-vivid-70);
  stroke-linecap: round;
  animation: loading-dash var(--loading-animation-duration) ease-in-out infinite;
}

.br-loading.loading-large .loading-indicator {
  animation-name: loading-dash-large;
}

.br-loading.loading-medium .loading-indicator {
  animation-name: loading-dash-medium;
}

.br-loading.loading-small .loading-indicator {
  animation-name: loading-dash-small;
}

.loading-indicator-progress {
  stroke: var(--blue-warm-vivid-70);
  stroke-linecap: round;
  transition: stroke-dashoffset var(--loading-transition-duration) ease;
  transform: rotate(-90deg);
  transform-origin: center;
}

.loading-percentage {
  font-size: var(--loading-percentage-font-size, var(--font-size-scale-up-02));
  font-weight: var(--font-weight-semi-bold);
  fill: var(--blue-warm-vivid-70);
  pointer-events: none;
}

.loading-label {
  font-size: var(--font-size-scale-base);
  font-weight: var(--font-weight-medium);
  color: var(--gray-80);
  text-align: center;
  margin-top: 16px;
}

@keyframes loading-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

@keyframes loading-dash-large {
  0% {
    stroke-dasharray: 1, 218;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 131, 218;
    stroke-dashoffset: -51;
  }

  100% {
    stroke-dasharray: 131, 218;
    stroke-dashoffset: -181;
  }
}

@keyframes loading-dash-medium {
  0% {
    stroke-dasharray: 6, 129;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 78, 129;
    stroke-dashoffset: -30;
  }

  100% {
    stroke-dasharray: 78, 129;
    stroke-dashoffset: -107;
  }
}

@keyframes loading-dash-small {
  0% {
    stroke-dasharray: 1, 80;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 48, 80;
    stroke-dashoffset: -19;
  }

  100% {
    stroke-dasharray: 48, 80;
    stroke-dashoffset: -66;
  }
}
